<template>
  <span :id="'commentSpan-' + order_id" v-if="comment != null"
    ><img
      src="@/assets/images/doorder/comment-icon-yellow.png"
      class="comment-img"
      alt="comment icon"
    />
    <b-popover
      :target="'commentSpan-' + order_id"
      :container="'commentSpan-' + order_id"
      triggers="hover"
      placement="left"
    >
      {{ comment }}
    </b-popover></span
  >
  <img
    v-else
    src="@/assets/images/doorder/no-comment-grey.png" class="comment-img"
    alt="comment icon"
  />
</template>
<script>
export default {
  name: "Comment",
  props: ["order_id", "comment"],
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/orders/datatable_custom_cells/Comment.vue